import { Box, Card, Group } from '@mantine/core';
import clsx from 'clsx';
import { type FC, useCallback } from 'react';
import Markdown from 'react-markdown';
import styles from '@/components/flow-card/flow-card.module.css';
import LibraryCardAction from '@/components/library-card/components/library-card-action';
import { LibraryCardViewMode } from '@/components/library-card/components/library-card-view-mode';
import type { TLibraryItemFrontend } from '@/types/common';
import { editorValueToMarkdown } from '@/utils/editor-conversion';

interface LibraryCardProps {
	data: TLibraryItemFrontend;
	type: string;
	color: string;
	isUsed: boolean;
	onAdd: (type: string, data: TLibraryItemFrontend) => void;
}

const LibraryCard: FC<LibraryCardProps> = ({
	data,
	type,
	color,
	isUsed,
	onAdd
}) => {
	const handleAdd = useCallback(() => {
		onAdd(type, data);
	}, [onAdd, type, data]);
	return (
		<div
			className={clsx(
				'notranslate',
				styles.wrapper,
				styles.libraryCardBackground
			)}
			style={{ '--type-color': color } as React.CSSProperties}
			translate="no"
		>
			<Card
				className={clsx(styles.card, styles.disabledCard)}
				padding="md"
				radius="md"
				shadow="sm"
			>
				<Box className={styles.heading}>
					<Group
						justify="space-between"
						wrap="nowrap"
					>
						<Box className={styles.title}>
							<Markdown>{editorValueToMarkdown(data.title)}</Markdown>
						</Box>

						{isUsed ? undefined : <LibraryCardAction onAdd={handleAdd} />}
					</Group>
				</Box>
				<LibraryCardViewMode
					body={editorValueToMarkdown(data.body)}
					color={color}
					description={data.description}
				/>
			</Card>
		</div>
	);
};

export default LibraryCard;
